var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"fake-sticky",rawName:"v-fake-sticky",value:({ offset: _setup.stickyElOffset }),expression:"{ offset: stickyElOffset }"}],ref:"stickyEl",staticClass:"sticky-bar",class:_setup.position},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }